import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import Image from 'next/image';
import { memo } from 'react';

interface AmbassadorMeta {
  deliveryKey: string;
  [key: string]: any;
}

interface AmbassadorItem {
  name: string;
  title?: string;
  avatar: any;
  city?: string;
  stateProvince?: string;
  country?: string;
  _meta?: AmbassadorMeta;
}

interface AmbassadorsGridItemProps {
  item: AmbassadorItem;
}

const AmbassadorsGridItem = ({ item }: AmbassadorsGridItemProps) => {
  const { name, title, avatar, city, stateProvince, country, _meta } = item || {};
  const imgUrl = buildImageSrc(avatar, 300, 4, 5);
  const linkObj = buildLinkObj({ link: _meta?.deliveryKey });

  return (
    <div className="tw-flex tw-flex-col tw-p-3 lg:tw-p-6 tw-h-full">
      <a
        rel={getRel(linkObj)}
        href={linkObj.href}
      >
        <div className="tw-relative tw-w-full tw-aspect-[4/5]">
          <Image
            src={imgUrl}
            alt="Ambassador Profile"
            fill
            sizes="(max-width: 768px) 100vw, 300px"
            className="tw-object-cover"
          />
        </div>
        <div className="tw-flex-1 tw-p-4 tw-border tw-border-neutral-200 tw-border-t-0">
          <h6 className="tw-font-bold tw-text-left tw-mb-4">{name}</h6>
          {title && (
            <p className="tw-text-left tw-mb-2 tw-text-brand-500 tra-text-web-sub-2">{title}</p>
          )}
          {city && stateProvince && (
            <p className="tw-mb-0 tw-text-warm-500">
              {city}
              {city && stateProvince ? <>,&nbsp;</> : null}
              {stateProvince}
              {(city || stateProvince) && country ? <>,&nbsp;</> : null}
              {country}
            </p>
          )}
        </div>
      </a>
    </div>
  );
};

export default memo(AmbassadorsGridItem);